import { render, staticRenderFns } from "./DeliveryArrange.vue?vue&type=template&id=7937b779"
import script from "./DeliveryArrange.vue?vue&type=script&lang=js"
export * from "./DeliveryArrange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports